import React from 'react';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from './CandidateQualifiedIndicator.module.scss';
import messages from './CandidateCardMessages';

function CandidateQualifiedIndicator() {
  return (
    <div className={styles.candidateQualifiedIndicator}>
      <Icon type="check-circle" theme="filled" className={styles.candidateQualifiedIndicatorIcon} />
      <div className={styles.candidateQualifiedIndicatorText}>
        <span>
          <FormattedMessage {...messages.qualifiedLabel} />
        </span>
      </div>
    </div>
  );
}

export default CandidateQualifiedIndicator;
